export function getDocTitleSlug(title: string) {
  return encodeURIComponent(
    title.toLowerCase().replace(/[\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, "-")
  );
}
